<template>
  <div class="page-header">
    <h2>Gestion des Tickets</h2>
    <button
      @click="openCleanModal"
      class="btn btn-warning"
      title="Supprimer les tickets en attente expirés"
    >
      🧹 Nettoyer les tickets expirés
    </button>
  </div>
  <!-- Messages d'info -->
  <InfoBox
    v-if="infoMessage"
    v-model:open="infoOpen"
    :type="infoType"
    @close="infoOpen = false; infoMessage = ''"
  >
    {{ infoMessage }}
  </InfoBox>
  <!-- Filtres -->
  <div class="filters form-group">
    <!-- Filtres avancés -->
    <div class="btn-group">
      <div class="filters-group">
        <label>UUID / Téléphone</label>
        <input v-model="filters.search" type="text" placeholder="Rechercher..." />
      </div><div class="filters-group">
        <label>Statut</label>
        <select v-model="filters.status">
          <option value="">Tous</option>
          <option value="PENDING_PAYMENT">En attente</option>
          <option value="paid">Payé</option>
          <option value="validated">Validé</option>
          <option value="refunded">Remboursé</option>
          <option value="cancelled">Annulé</option>
        </select>
      </div>
      <div class="filters-group">
        <label>Date de début</label>
        <input v-model="filters.dateStart" type="date" @change="filters.period = 'custom'" />
      </div>
      <div class="filters-group">
        <label class="field__label">Date de fin</label>
        <input v-model="filters.dateEnd" type="date" @change="filters.period = 'custom'" />
      </div>
      <div class="filters-group">
        <label>Compagnie</label>
        <input v-model="filters.company" type="text" placeholder="Rechercher..." />
      </div>
      <div class="filters-group">
        <label>Ville de départ</label>
        <input v-model="filters.cityStart" type="text" placeholder="Rechercher..." />
      </div>
      <div class="filters-group">
        <label>Ville d'arrivée</label>
        <input v-model="filters.cityEnd" type="text" placeholder="Rechercher..." />
      </div>
    </div>
    <!-- Filtres rapides -->
    <div class="btn-group">
      <div>
        <button @click="setDatePeriod('current_month')" :class="['btn btn-chip', { 'is-active': filters.period === 'current_month' }]">Ce mois</button>
        <button @click="setDatePeriod('last_month')" :class="['btn btn-chip', { 'is-active': filters.period === 'last_month' }]">Mois dernier</button>
        <button @click="setDatePeriod('last_3_months')" :class="['btn btn-chip', { 'is-active': filters.period === 'last_3_months' }]">3 derniers mois</button>
        <button @click="setDatePeriod('last_6_months')" :class="['btn btn-chip', { 'is-active': filters.period === 'last_6_months' }]">6 derniers mois</button>
        <button @click="setDatePeriod('all')" :class="['btn btn-chip', { 'is-active': filters.period === 'all' }]">Tout afficher</button>
      </div>
    </div>
    <!-- Nombre de Résultats -->
    <div class="btn-group">
      <span class="badge badge-info">
        {{ filteredTickets.length }} ticket(s) trouvé(s) sur {{ allTickets.length }}
      </span>
      <button @click="resetFilters" class="btn btn-secondary">Réinitialiser</button>
    </div>
  </div>
  <!-- Tableau des tickets -->
  <table v-if="!loading && allTickets.length > 0" class="table">
    <thead>
      <tr>
        <th @click="sortBy('uuid')" class="th--sortable">UUID <span class="sort-icon">{{ getSortIcon('uuid') }}</span></th>
        <th @click="sortBy('user')" class="th--sortable">Utilisateur <span class="sort-icon">{{ getSortIcon('user') }}</span></th>
        <th @click="sortBy('status')" class="th--sortable">Statut <span class="sort-icon">{{ getSortIcon('status') }}</span></th>
        <th @click="sortBy('createdAt')" class="th--sortable">Créé le <span class="sort-icon">{{ getSortIcon('createdAt') }}</span></th>
        <th @click="sortBy('trip')" class="th--sortable">Trajet <span class="sort-icon">{{ getSortIcon('trip') }}</span></th>
        <th @click="sortBy('timeToStart')" class="th--sortable">Départ <span class="sort-icon">{{ getSortIcon('timeToStart') }}</span></th>
        <!--<th @click="sortBy('price')" class="th--sortable">Prix <span class="sort-icon">{{
getSortIcon('price') }}</span></th>-->
        <th @click="sortBy('company')" class="th--sortable">Compagnie <span class="sort-icon">{{ getSortIcon('company') }}</span></th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="ticket in visibleTickets" :key="ticket.uuid" class="row">
        <td><span class="mono help" :title="ticket.uuid">{{ ticket.uuid.slice(0, 8) }}...</span></td>
        <td>
          <span v-if="ticket.payerPhone">📱 {{ ticket.payerPhone }}</span>
          <span v-else-if="ticket.user?.phone">👤 {{ ticket.user.phone }}</span>
          <span v-else class="muted">-</span></td>
        <td>
          <span :class="['badge','badge-' + getTicketStatus(ticket).toLowerCase().replace('_', '-')]">
            {{ getStatusLabel(getTicketStatus(ticket)) }}
          </span>
        </td>
        <td>{{ formatDate(ticket.createdAt) }}</td>
        <td><div class="route">{{ ticket.trip?.addressToStart?.city?.name || 'N/A' }} → {{ ticket.trip?.addressToEnd?.city?.name || 'N/A' }}</div></td>
        <td>{{ formatDateTime(ticket.trip?.timeToStart) }}</td>
        <!--<td class="price">{{ ticket.trip?.price || 0 }}€</td>-->
        <td>{{ ticket.trip?.company?.name || 'N/A' }}</td>
        <td>
          <button
            v-if="canValidate(ticket)"
            @click="openValidateModal(ticket)"
            class="icon-btn icon-btn-success"
            title="Valider"
          >
            ✅
          </button>
          <button v-if="canRefund(ticket)" @click="openRefundModal(ticket)" class="icon-btn icon-btn--warning" title="Rembourser">💰</button>
          <button v-if="canDelete(ticket)" @click="openDeleteModal(ticket)" class="icon-btn danger" title="Supprimer">🗑</button>
          <span v-if="!canValidate(ticket) && !canRefund(ticket) && !canDelete(ticket)" class="muted">-</span>
        </td>
      </tr>
    </tbody>
  </table>
  <!-- État vide -->
  <EmptyState
    v-if="!loading && filteredTickets.length === 0 && allTickets.length > 0"
    :is-empty="true"
    emptyMessage="Aucun ticket ne correspond aux filtres"
  />
  <!-- Charger plus -->
  <div v-if="!loading && visibleTickets.length > 0 && visibleCount < filteredTickets.length"
    class="btn-group center">
    <button @click="loadMore" class="btn">- Charger plus -</button>
  </div>
  <!-- État vide -->
  <EmptyState
    v-if="!loading && allTickets.length === 0"
    :is-empty="true"
    emptyMessage="Aucun ticket ne correspond aux filtres"
  />
</template>

<script setup>
import { config } from '@/config/env.js'
import { ref, onMounted, computed } from 'vue'
import { useToast } from 'vue-toast-notification'
import { useModalStore } from '@/stores/modalStore'
import FormFieldsRefund from '@/components/FormFields/FormFieldsRefund.vue'
import InfoBox from '@/components/InfoBox.vue'

const emit = defineEmits(['loading'])
const toast = useToast()
const modalStore = useModalStore()
const infoOpen = ref(false)
const infoType = ref('info')
const infoMessage = ref('')

const allTickets = ref([])
const loading = ref(false)
const visibleCount = ref(10)
const ITEMS_STEP = 10

const sortKey = ref('createdAt')
const sortOrder = ref('desc')

const filters = ref({
  search: '',
  status: '',
  period: 'current_month',
  dateStart: '',
  dateEnd: '',
  company: '',
  cityStart: '',
  cityEnd: ''
})

const getTicketStatus = (ticket) => {
  if (ticket.validatedAt) return 'validated'
  return ticket.status
}

const getStatusLabel = (status) => {
  const normalizedStatus = status?.toLowerCase()
  const labels = {
    'pending_payment': 'En attente',
    'paid': 'Payé',
    'validated': 'Validé',
    'refunded': 'Remboursé',
    'cancelled': 'Annulé'
  }
  return labels[normalizedStatus] || status
}

const canValidate = (ticket) => getTicketStatus(ticket).toLowerCase() === 'paid'
const canDelete = (ticket) => getTicketStatus(ticket).toLowerCase() === 'pending_payment'

const canRefund = (ticket) => {
  if (!ticket) return false
  const status = getTicketStatus(ticket)?.toLowerCase()
  return status === 'paid' && !ticket.validatedAt
}

const setDatePeriod = (period) => {
  filters.value.period = period
  const now = new Date()
  const year = now.getFullYear()
  const month = now.getMonth()

  switch (period) {
    case 'current_month':
      filters.value.dateStart = new Date(year, month, 1).toISOString().split('T')[0]
      filters.value.dateEnd = new Date(year, month + 1, 0).toISOString().split('T')[0]
      break
    case 'last_month':
      filters.value.dateStart = new Date(year, month - 1, 1).toISOString().split('T')[0]
      filters.value.dateEnd = new Date(year, month, 0).toISOString().split('T')[0]
      break
    case 'last_3_months':
      filters.value.dateStart = new Date(year, month - 3, 1).toISOString().split('T')[0]
      filters.value.dateEnd = new Date(year, month + 1, 0).toISOString().split('T')[0]
      break
    case 'last_6_months':
      filters.value.dateStart = new Date(year, month - 6, 1).toISOString().split('T')[0]
      filters.value.dateEnd = new Date(year, month + 1, 0).toISOString().split('T')[0]
      break
    case 'all':
      filters.value.dateStart = ''
      filters.value.dateEnd = ''
      break
  }
}

const resetFilters = () => {
  filters.value = {
    search: '',
    status: '',
    period: 'current_month',
    dateStart: '',
    dateEnd: '',
    company: '',
    cityStart: '',
    cityEnd: ''
  }
  setDatePeriod('current_month')
  visibleCount.value = ITEMS_STEP
}

const filteredTickets = computed(() => {
  return allTickets.value.filter(ticket => {
    if (filters.value.search) {
      const searchTerm = filters.value.search.toLowerCase()
      const uuid = ticket.uuid.toLowerCase()
      const phone = ticket.user?.phone?.toLowerCase() || ''
      if (!uuid.includes(searchTerm) && !phone.includes(searchTerm)) return false
    }

    if (filters.value.status) {
      const ticketStatus = getTicketStatus(ticket).toUpperCase()
      const filterStatus = filters.value.status.toUpperCase()
      const normalizedTicketStatus = ticketStatus.replace('_', '')
      const normalizedFilterStatus = filterStatus.replace('_', '')
      if (normalizedTicketStatus !== normalizedFilterStatus) return false
    }

    if (filters.value.dateStart) {
      const ticketDate = new Date(ticket.createdAt).toISOString().split('T')[0]
      if (ticketDate < filters.value.dateStart) return false
    }

    if (filters.value.dateEnd) {
      const ticketDate = new Date(ticket.createdAt).toISOString().split('T')[0]
      if (ticketDate > filters.value.dateEnd) return false
    }

    if (filters.value.company) {
      const searchTerm = filters.value.company.toLowerCase()
      const companyName = ticket.trip?.company?.name?.toLowerCase() || ''
      if (!companyName.includes(searchTerm)) return false
    }

    if (filters.value.cityStart) {
      const searchTerm = filters.value.cityStart.toLowerCase()
      const cityName = ticket.trip?.addressToStart?.city?.name?.toLowerCase() || ''
      if (!cityName.includes(searchTerm)) return false
    }

    if (filters.value.cityEnd) {
      const searchTerm = filters.value.cityEnd.toLowerCase()
      const cityName = ticket.trip?.addressToEnd?.city?.name?.toLowerCase() || ''
      if (!cityName.includes(searchTerm)) return false
    }

    return true
  })
})

const sortedTickets = computed(() => {
  const tickets = [...filteredTickets.value]
  tickets.sort((a, b) => {
    let aVal, bVal
    switch (sortKey.value) {
      case 'uuid': aVal = a.uuid || ''; bVal = b.uuid || ''; break
      case 'user': aVal = a.user?.phone || ''; bVal = b.user?.phone || ''; break
      case 'status': aVal = getTicketStatus(a); bVal = getTicketStatus(b); break
      case 'createdAt': aVal = new Date(a.createdAt); bVal = new Date(b.createdAt); break
      case 'trip': aVal = `${a.trip?.addressToStart?.city?.name || ''} ${a.trip?.addressToEnd?.city?.name || ''}`; bVal = `${b.trip?.addressToStart?.city?.name || ''} ${b.trip?.addressToEnd?.city?.name || ''}`; break
      case 'timeToStart': aVal = new Date(a.trip?.timeToStart || 0); bVal = new Date(b.trip?.timeToStart || 0); break
      // case 'price': aVal = a.trip?.price || 0; bVal = b.trip?.price || 0; break
      case 'company': aVal = a.trip?.company?.name || ''; bVal = b.trip?.company?.name || ''; break
      default: return 0
    }
    if (aVal < bVal) return sortOrder.value === 'asc' ? -1 : 1
    if (aVal > bVal) return sortOrder.value === 'asc' ? 1 : -1
    return 0
  })
  return tickets
})

const visibleTickets = computed(() => sortedTickets.value.slice(0, visibleCount.value))

const sortBy = (key) => {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc'
  } else {
    sortKey.value = key
    sortOrder.value = 'asc'
  }
}

const getSortIcon = (key) => sortKey.value !== key ? '⇅' : (sortOrder.value === 'asc' ? '↑' : '↓')
const loadMore = () => { if (visibleCount.value < sortedTickets.value.length) visibleCount.value += ITEMS_STEP }

onMounted(async () => {
  setDatePeriod('current_month')
  await loadTickets()
})

const loadTickets = async () => {
  loading.value = true
  emit('loading', true)

  try {
    const res = await fetch(config.apiUrl + '/tickets', { credentials: 'include' })

    if (res.ok) {
      allTickets.value = await res.json()
      visibleCount.value = ITEMS_STEP
    } else {
      showInfo('error', 'Erreur lors du chargement des tickets')
      toast.error('Erreur lors du chargement des tickets')
    }
  } catch (err) {
    showInfo('error', err?.message || 'Erreur de connexion')
    toast.error('Erreur de connexion')
  } finally {
    loading.value = false
    emit('loading', false)
  }
}

// 🎯 NETTOYAGE
const openCleanModal = async () => {
  const { result } = modalStore.open({
    kind: 'confirm',
    title: 'Nettoyer les tickets expirés',
    message: '⚠️ Cette action va supprimer tous les tickets en attente de paiement expirés (créés il y a plus de 24 heures).\n\nÊtes-vous sûr de vouloir continuer ?',
    confirmText: 'Supprimer',
    cancelText: 'Annuler'
  })
  const res = await result
  if (res.action === 'confirm') await handleCleanTickets()
}

const handleCleanTickets = async () => {
  loading.value = true
  emit('loading', true)

  try {
    const csrfRes = await fetch(config.apiUrl + '/csrf', {
      method: 'GET',
      credentials: 'include'
    })
    const { token } = await csrfRes.json()

    const res = await fetch(config.apiUrl + '/tickets/delete-old-pending-tickets', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'X-CSRF-TOKEN': token
      }
    })

    const data = await res.json().catch(() => ({}))

    if (res.ok) {
      await loadTickets()
      toast.success(data.message || 'Tickets expirés supprimés')
      showInfo('success', data.message || 'Tickets expirés supprimés')
    } else {
      showInfo('error', error.value)
      toast.error(error.value)
    }
  } catch (err) {
    showInfo('error', 'Erreur de connexion')
    toast.error('Erreur de connexion')
  } finally {
    loading.value = false
    emit('loading', false)
  }
}


// 🎯 VALIDATION
const openValidateModal = async (ticket) => {
  const { result } = modalStore.open({
    kind: 'confirm',
    title: 'Valider le ticket',
    message: `Confirmer la validation de ce ticket ?

UUID: ${ticket.uuid}
Utilisateur: ${ticket.user?.phone || 'N/A'}
Statut: ${getStatusLabel(getTicketStatus(ticket))}`,
    confirmText: 'Valider',
    cancelText: 'Annuler'
  })
  const res = await result
  if (res.action === 'confirm') await handleValidateTicket(ticket.uuid)
}

const handleValidateTicket = async (uuid) => {
  loading.value = true
  emit('loading', true)

  try {
    const res = await fetch(`${config.apiUrl}/ticket/validate/${uuid}`, {
      method: 'POST',
      credentials: 'include'
    })

    if (res.ok) {
      await loadTickets()
      toast.success('Ticket validé avec succès')
      showInfo('success', 'Ticket validé avec succès')
    } else {
      let message = 'Erreur lors de la validation'
      try {
        const errData = await res.json()
        message = errData.message || message
      } catch (_) {}
      showInfo('error', message)
      toast.error(message)
    }
  } catch (err) {
    showInfo('error', err?.message || 'Erreur de connexion')
    toast.error('Erreur de connexion')
  } finally {
    loading.value = false
    emit('loading', false)
  }
}

// 🎯 REMBOURSEMENT
const openRefundModal = async (ticket) => {
  const { result } = modalStore.openComponent(
    FormFieldsRefund,
    { formData: { reason: '' }, ticket },
    { title: 'Rembourser le ticket', confirmText: 'Confirmer le remboursement', maxWidth:
      '600px', kind: 'default' }
  )
  const res = await result
  if (res.action === 'submit') await handleRefundTicket(ticket.uuid, res.data.reason)
}

const handleRefundTicket = async (uuid, reason) => {
  if (!reason.trim()) {
    showInfo('error', 'Veuillez indiquer une raison')
    toast.error('Veuillez indiquer une raison')
    return
  }

  loading.value = true
  emit('loading', true)

  try {
    const res = await fetch(`${config.apiUrl}/ticket/cancel/${uuid}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        reasonForRefund: reason,
        notchPayPublicKey: 'pk_test.h9ZaIIZWTF6TJNIX4XNEilefsEHSwPo1Qc4a4rk29VjCIMs2FkWUkexKFL2hwRqnPaeteExXTffY1cOHtX42aRH2Lh19bw8L5y341DffIwbIwnPCrHg6IkmODn98z'
      })
    })

    if (res.ok) {
      await loadTickets()
      toast.success('Ticket remboursé avec succès')
    } else {
      const errData = await res.json()
      showInfo('error', errData.message || 'Erreur lors du remboursement')
      toast.error(error.value)
    }
  } catch (err) {
    showInfo('error', 'Erreur de connexion')
    toast.error('Erreur de connexion')
  } finally {
    loading.value = false
    emit('loading', false)
  }
}

// 🎯 SUPPRESSION
const openDeleteModal = async (ticket) => {
  const { result } = modalStore.open({
    kind: 'confirm',
    title: 'Confirmer la suppression',
    message: `Êtes-vous sûr de vouloir supprimer ce ticket en attente ?

UUID: ${ticket.uuid}
Statut: ${getStatusLabel(getTicketStatus(ticket))}`,
    confirmText: 'Supprimer',
    cancelText: 'Annuler'
  })
  const res = await result
  if (res.action === 'confirm') await handleDeleteTicket(ticket.uuid)
}

const handleDeleteTicket = async (uuid) => {
  loading.value = true
  emit('loading', true)

  try {
    const res = await fetch(`${config.apiUrl}/ticket/${uuid}`, {
      method: 'DELETE',
      credentials: 'include'
    })

    if (res.ok) {
      await loadTickets()
      toast.success('Ticket supprimé avec succès')
    } else {
      showInfo('error', 'Erreur lors de la suppression du ticket')
      toast.error('Erreur lors de la suppression')
    }
  } catch (err) {
    showInfo('error', 'Erreur de connexion')
    toast.error('Erreur de connexion')
  } finally {
    loading.value = false
    emit('loading', false)
  }
}

const formatDate = (dateString) => {
  if (!dateString) return 'N/A'
  const date = new Date(dateString)
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
}

const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A'
  const date = new Date(dateString)
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}

const showInfo = (type, message) => {
  infoType.value = type
  infoMessage.value = message
  infoOpen.value = true
}
</script>
